import * as Sentry from '@sentry/react';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { throttle } from 'lodash';
import rootSaga from '@/sagas';
import rootReducer, { loadSettings, saveSettings, saveSessionSettings } from '@/app/state';

const composeEnhancers = (((typeof window !== 'undefined' && window.location.hostname.includes('aridhiadev'))
        || process.env.NODE_ENV === 'development')
        && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    || compose;

const sagaMiddleware = createSagaMiddleware({
  onError: (error, { sagaStack }) => {
    Sentry.captureException(error);

    /* eslint-disable no-console */
    console.error(error);
    console.error(sagaStack);
    /* eslint-enable no-console */
  },
});

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

export const makeStore = () => {
  const store = createStore(
    rootReducer,
    loadSettings(),
    composeEnhancers(
      applyMiddleware(thunk, sagaMiddleware),
      sentryReduxEnhancer,
    ),
  );

  store.subscribe(throttle(() => saveSettings(store.getState()), 1000));
  store.subscribe(throttle(() => saveSessionSettings(store.getState()), 1000));
  sagaMiddleware.run(rootSaga);

  return store;
};

export default makeStore();
